module.exports = __webpack_public_path__ + "static/media/1920-service-1-1-min.613957de.jpg";